// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b7bcb78a","453":"b69074f3","455":"5a9f6ed8","977":"781c0c1a"}[chunkId] + ".chunk.js";
};